module.exports = __webpack_public_path__ + "static/media/Omen.10de23fd.png";